const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class ProviderService {
  static async getAllProviders(token) {
    const response = await fetch(`${API_BASE_URL}/providers`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  static async getProviders(token, limit = 50, lastKey = null) {
    let url = `${API_BASE_URL}/providers?limit=${limit}`;
    if (lastKey) {
      url += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return {
      providers: data.data,
      pagination: data.pagination
    };
  }

  static async getProviderById(providerId, token) {
    const response = await fetch(`${API_BASE_URL}/providers/${providerId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.data;
  }

  static async createProvider(providerData, token) {
    const response = await fetch(`${API_BASE_URL}/providers`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(providerData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.data;
  }

  static async updateProvider(providerId, providerData, token) {
    const response = await fetch(`${API_BASE_URL}/providers/${providerId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(providerData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.data;
  }

  static async deleteProvider(providerId, token) {
    const response = await fetch(`${API_BASE_URL}/providers/${providerId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  static async searchProviders(query, token) {
    const response = await fetch(`${API_BASE_URL}/providers/search?query=${encodeURIComponent(query)}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.data;
  }
}

export default ProviderService;
